module.exports = __webpack_public_path__ + "img/6.117d62a7.jpg";